export default {
  title: 'Illustrations for Medical Professionals',
  metaDescription:
    'Visualize human anatomy with ready made 40,000+ biological and scientific illustrations to design beautiful scientific and educational infographics and presentations.',
  keywords:
    'medical illustration, medical illustration vector, visual human anatomy, biological illustration, scientific illustration',
  exploreText: '...or explore all our 50+ illustration categories',
  showMore: 'Show more',
  checkOutText: 'Check out our variety of',
  createUniqueText:
    'icons, illustrations and images. Use them to create unique scientific, academic and educational',
  infographicsText: 'infographics and presentations.',
};
